<!-- p-ticket-filter.component.html -->

<div style="display: flex; flex-direction: column">

  <!-- Reusable chip-trigger + dropdown panel (exact/product/tickettype/issuetype/severity/component/statusGranulated) -->
  <ng-template #chipSelectTemplate let-value="value" let-options="options" let-displayFn="displayFn"
    let-placeholder="placeholder" let-onSelect="onSelect" let-panelOpen="panelOpen" let-togglePanel="togglePanel"
    let-closePanel="closePanel">
    <mat-chip cdkOverlayOrigin #chipTrigger="cdkOverlayOrigin" (click)="togglePanel()" class="filter-chip"
      [matTooltip]="value ? (displayFn ? displayFn(value) : value) : placeholder">
      <span class="filter-chip-label">{{ value ? (displayFn ? displayFn(value) : value) : placeholder }}</span>
      <mat-icon class="chip-caret" matChipRemove (click)="togglePanel()">arrow_drop_down</mat-icon>
    </mat-chip>











    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="chipTrigger" [cdkConnectedOverlayOpen]="panelOpen"
      [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      (backdropClick)="closePanel()" (detach)="closePanel()">
      <div class="chip-dropdown-panel">
        <div *ngFor="let option of options" class="chip-dropdown-option" [class.selected]="option === value"
          (click)="onSelect(option); closePanel()">
          {{ displayFn ? displayFn(option) : option }}
        </div>
      </div>
    </ng-template>
  </ng-template>

  <!-- Reusable text input + live-suggestion dropdown (country / user / useremail / company / callbacknumber) -->
  <ng-template #textAutocompleteTemplate let-value="value" let-placeholder="placeholder" let-suggestions="suggestions"
    let-isLoading="isLoading" let-displayFn="displayFn" let-onInput="onInput" let-onSelect="onSelect"
    let-panelOpen="panelOpen" let-openPanel="openPanel" let-closePanel="closePanel">

    <div class="free-input-wrapper" cdkOverlayOrigin #autoTrigger="cdkOverlayOrigin">
      <input type="text" class="free-input" [ngModel]="value" (ngModelChange)="onInput($event)" (focus)="openPanel()"
        [placeholder]="placeholder" />
      <mat-icon *ngIf="value" class="free-input-clear" (click)="onInput(''); $event.stopPropagation()">
        close
      </mat-icon>
    </div>

    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="autoTrigger"
      [cdkConnectedOverlayOpen]="panelOpen && (isLoading || suggestions?.length)"
      [cdkConnectedOverlayHasBackdrop]="true" cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
      (backdropClick)="closePanel()" (detach)="closePanel()">
      <div class="chip-dropdown-panel">
        <div *ngIf="isLoading" class="chip-dropdown-option chip-dropdown-loading">Loading…</div>
        <ng-container *ngIf="!isLoading">
          <div *ngFor="let s of suggestions" class="chip-dropdown-option" (click)="onSelect(s); closePanel()">
            {{ displayFn ? displayFn(s) : s }}
          </div>
        </ng-container>
      </div>
    </ng-template>
  </ng-template>

  <!-- Filter row template -->
  <ng-template #filterRowTemplate let-item="item" let-onColumnChange="onColumnChange" let-onValueChange="onValueChange"
    let-onRemove="onRemove">
    <div class="filter-row">

      <div class="col-label">Where</div>

      <!-- Column chip-select -->
      <div class="col-column">
        <ng-container *ngTemplateOutlet="
            chipSelectTemplate;
            context: {
              value: item.key,
              options: filterOptions,
              displayFn: displayKeyFn,
              placeholder: 'Column',
              onSelect: makeColumnSelectHandler(item, onColumnChange),
              panelOpen: item._columnPanelOpen,
              togglePanel: makeTogglePanel(item, 'columnPanel'),
              closePanel: makeClosePanel(item, 'columnPanel')
            }
          "></ng-container>
      </div>

      <div class="col-operator">
        <span *ngIf="!item.key || item.key.filterType !== 'dateRange'">contains</span>
        <span *ngIf="item.key?.filterType === 'dateRange'">is between</span>
      </div>

      <div class="col-value">

        <mat-chip *ngIf="!item.key" disabled class="filter-chip">
          <span class="filter-chip-label">Value</span>
        </mat-chip>

        <!-- exact: chip-select over item.key.options -->
        <ng-container *ngIf="item.key?.filterType === 'exact'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: item.key.options,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- country: custom autocomplete, no Material -->
        <ng-container *ngIf="item.key?.filterType === 'country'">
          <ng-container *ngTemplateOutlet="
              textAutocompleteTemplate;
              context: {
                value: item.value,
                placeholder: 'Value',
                suggestions: filteredcountryCodes,
                isLoading: false,
                displayFn: displayCountryFn,
                onInput: makeCountryInputHandler(item, onValueChange),
                onSelect: makeCountrySelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                openPanel: makeOpenPanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>


        <!-- product: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'product'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: productOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- pKeyword: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'pKeyword'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: pKeywordOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- tickettype: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'tickettype'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: tickettypeOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- issuetype: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'issuetype'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: issuetypeOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- severity: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'severity'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: severityOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- component: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'component'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: componentOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- statusGranulated: chip-select -->
        <ng-container *ngIf="item.key?.filterType === 'statusGranulated'">
          <ng-container *ngTemplateOutlet="
              chipSelectTemplate;
              context: {
                value: item.value,
                options: statusGranulatedOptionValues,
                displayFn: null,
                placeholder: 'Value',
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                togglePanel: makeTogglePanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- textAutocomplete: user / useremail / company / callbacknumber -->
        <ng-container *ngIf="item.key?.filterType === 'textAutocomplete'">
          <ng-container *ngTemplateOutlet="
              textAutocompleteTemplate;
              context: {
                value: item.value,
                placeholder: 'Value',
                suggestions: item._suggestions,
                isLoading: item._suggestionsLoading,
                displayFn: null,
                onInput: makeAutocompleteInputHandler(item, onValueChange),
                onSelect: makeValueSelectHandler(item, onValueChange),
                panelOpen: item._valuePanelOpen,
                openPanel: makeOpenPanel(item, 'valuePanel'),
                closePanel: makeClosePanel(item, 'valuePanel')
              }
            "></ng-container>
        </ng-container>

        <!-- freeSearch: plain custom compact input (description, author, creator, system version, communication) -->
        <div *ngIf="item.key?.filterType === 'freeSearch'" class="free-input-wrapper">
          <input type="text" class="free-input" [ngModel]="item.value" (ngModelChange)="onValueChange(item, $event)"
            placeholder="Value" />
          <mat-icon *ngIf="item.value" class="free-input-clear"
            (click)="onValueChange(item, ''); $event.stopPropagation()">
            close
          </mat-icon>
        </div>

        <!-- dateRange: two native date inputs, no Material -->
        <div *ngIf="item.key?.filterType === 'dateRange'" class="date-range-wrapper">
          <input type="date" class="date-input" [ngModel]="toDateInputValue(item.value?.start)"
            (ngModelChange)="onValueChange(item, { start: fromDateInputValue($event), end: item.value?.end })" />
          <span class="date-range-sep">–</span>
          <input type="date" class="date-input" [ngModel]="toDateInputValue(item.value?.end)"
            (ngModelChange)="onValueChange(item, { start: item.value?.start, end: fromDateInputValue($event) })" />
        </div>
      </div>

      <div class="col-remove">
        <button mat-icon-button (click)="onRemove(item)">
          <mat-icon>close</mat-icon>
        </button>
      </div>

    </div>
  </ng-template>

  <ng-container *ngFor="let filter of filters">
    <ng-container *ngTemplateOutlet="
        filterRowTemplate;
        context: {
          item: filter,
          onColumnChange: onFilterColumnChange.bind(this),
          onValueChange: onFilterValueChange.bind(this),
          onRemove: removeFilter.bind(this)
        }
      "></ng-container>
  </ng-container>

  <div style="display: flex; flex-direction: row">
    <button mat-button (click)="removeAllFilters()">
      Clear All
    </button>

    <button mat-button (click)="addFilterRow()">
      Add
    </button>

    <span class="example-spacer"></span>

    <button mat-raised-button color="primary" (click)="apply()">
      Apply
    </button>
  </div>

</div>